import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttestationDetailsService {

  constructor(public http:HttpClient) { }

  public getDasFormDetails(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_PUCA+'das/twes',payload)
  }

  public saveApplicationData(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PUCA+'das/saveApplicationData',payload)
  }

  public validateStampNumber(number):Observable<any>{
    return this.http.get(environment.BASE_URL_PUCA+'das/validateStampNumber/'+number)
  }

  public DistrictList():Observable<any>{
    return this.http.get(environment.BASE_URL_COMMON+'cmn/getDistrictList')
  }

  public getRegionalCentreByDistrictId(id):Observable<any>{
    return this.http.get(environment.BASE_URL_COMMON+'cmn/getRegionalCentreByDistrictId/'+id)
  }
}
